<div
  class="custom-checkbox"
>
  <input
    type="checkbox"
    #ele
    [id]=" id"
    [checked]="!!model"
    [disabled]="control.disabled || parentFormVMDisabled()"
    [name]="name"
    (change)="_onChange(ele.checked)"
    [value]="value"
  />
  <label class="label" [ngClass]="{ disabled: disabled }" [for]=" id">
    {{ label || value }}
  </label>
</div>
